export type IsE2e = boolean;

/**
 * @ngdoc service
 * @name v6CoreModule.isE2e
 * @description
 * a flag is supposed to be true if we are running e2e, false otherwise.
 */
angular.module('v6CoreModule').value('isE2e', false);
